import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';

type Props = {
  onClose?: () => void;
};

const CloseButton: React.FC<Props> = ({ onClose }) => (
  <IconButton size="small" onClick={onClose}>
    <Close fontSize="small" />
  </IconButton>
);

export default CloseButton;
